<template>
	<div
		class="offline"
		v-if="$mq.isOffline()"
		:style=""
	/>
</template>

<script>
export default {
	data () {
		return {
			
		}
	}
}
</script>

<style scoped>
.offline {
  opacity: 0.7;
  background-color: white;
  position: fixed;
  height: 100vh;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
}
</style>
